<template>
  <div class="content">
    <div class="list">
      <div class="item" v-for="item in modelList" :key="item.name" @click="seleckModel(item.name)">
        <img class="car-img" :src="item.src" alt="">
        <span>{{item.name}}</span>
        <img class="right" :src="public_path + '/static/images/arrow_right.svg'" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      public_path: process.env.PUBLICK_PATH,
      modelList: [
        {
          src: `${process.env.PUBLICK_PATH}/static/images/stn.jpg`,
          name: '大众新桑塔纳'
        },
        {
          src: `${process.env.PUBLICK_PATH}/static/images/skd.jpg`,
          name: '斯柯达'
        },
        {
          src: `${process.env.PUBLICK_PATH}/static/images/jd.jpg`,
          name: '大众新捷达'
        },
        {
          src: `${process.env.PUBLICK_PATH}/static/images/byd.jpg`,
          name: '比亚迪速锐'
        },
        {
          src: `${process.env.PUBLICK_PATH}/static/images/xbl.jpg`,
          name: '大众新宝来'
        },
        {
          src: `${process.env.PUBLICK_PATH}/static/images/dfbz301.jpg`,
          name: '东风标志301'
        },
        {
          src: `${process.env.PUBLICK_PATH}/static/images/xtl.jpg`,
          name: '东风雪铁龙新爱丽舍'
        },
        {
          src: `${process.env.PUBLICK_PATH}/static/images/dnV5.jpg`,
          name: '东南V5'
        },
        {
          src: `${process.env.PUBLICK_PATH}/static/images/cq.jpg`,
          name: '广汽传祺GA3S'
        },
        {
          src: `${process.env.PUBLICK_PATH}/static/images/cqGA5.jpg`,
          name: '广汽传祺GA5'
        },
        {
          src: `${process.env.PUBLICK_PATH}/static/images/yd.jpg`,
          name: '长安逸动'
        },
        {
          src: `${process.env.PUBLICK_PATH}/static/images/car.png`,
          name: '其他'
        }
      ]
    }
  },
  methods: {
    seleckModel (name) {
      sessionStorage.setItem('car_model', name)
      this.$router.back(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.list {
  .item {
    padding: .35rem .5rem;
    border-bottom: 1px solid rgba(186,186,186,0.4);
    display: -webkit-flex;
    display: flex;
    align-items: center;
    .car-img {
      width: 2rem;
      height: 1.3rem;
    }
    span {
      font-size: .34rem;
      flex: 1;
      margin-left: .4rem;
    }
    .right {
      width: .14rem;
      height: .25rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/buyModel/buyModel.vue